/** @module                         Hooks */

import { useTranslation }           from "react-i18next";

import { usePagename }              from "../../../Hooks/usePagename";

import { useEffect, useState }      from "react";

import { useNavigate }              from "react-router-dom";

import useCreate                    from "../../../Hooks/Mutations/useCreate";

/** @module                         GQL */

import { CREATE_LEGAL_DATA }        from "../../../Mutations/Contacts";

import { LEGAL_DATA_LIST }          from "../../../Queries/Contacts";

/** @module                         Components */

import Breadcrumbs                  from "../../../Components/Dashboard/Breadcrumbs";

import AsideEdit                    from "../../../Components/Dashboard/Global/Layouts/Mutations/Aside";

import Fieldset                     from "../../../Components/Dashboard/Global/Forms/Fieldset";

import Checkbox                     from "../../../Components/Dashboard/Global/Forms/Checkbox";

import { LabeledInput }             from "../../../Components/Dashboard/Global/Forms/Inputs_Spread";

import BankAccountsList             from "../../../Components/Dashboard/BankAccounts/BankAccountsList";

const

/**
 *
 * @returns create mutation
 *
 */

AddLegalData = ( { name } ) => {

    /** @event usePagename */

    usePagename ( name );

    const

    { t }       = useTranslation (),

    navigate    = useNavigate (),

    /** @callback useCreate create mutation hook */

    {

        createMutation,

        loading,

        complete,

        returnData,

        errors,

        setErrors

    } = useCreate ( CREATE_LEGAL_DATA, {

        refetchQueries: [ { query: LEGAL_DATA_LIST } ]

    } ),

    /** @event useState form fields */

    [ state, setState ] = useState ( {

        legalEntityName: "",

        registrationNumber: "",

        countryCode: "",

        legalAddress: "",

        factualAddress: "",

        phone: "",

        servicePhone: "",

        email: "",

        bankAccounts: []

    } ),

    /**
     *
     * @param { Object } e
     *
     * @event onSubmit
     *
     */

    onSubmit = e => { e.preventDefault ();

        if (

            ! state.legalEntityName ||

            ! state.registrationNumber

        ) { return setErrors ( true ); }

        const mutationData = {

            ...state,

            bankAccountsAttributes: formatBankAccountsAttributes ( state.bankAccounts ) ?? []

        };

        delete mutationData.bankAccounts;

        createMutation ( mutationData );

    },

    /**
     *
     * @param { Object } e
     *
     * @event handleChange
     *
     */

    handleChange = e => { const { name, value, type, checked } = e.target;

        if ( type === "checkbox" ) return setState ( prev => ( { ...prev, [ name ]: checked } ) );

        setState ( prev => ( { ...prev, [ name ]: value } ) );

    },

    handleBankAccountsChange = updatedBankAccounts => {

        setState ( prev => ( { ...prev, bankAccounts: updatedBankAccounts } ) );

    },

    formatBankAccountsAttributes = bankAccounts => {

        if ( ! bankAccounts || bankAccounts.length === 0 ) return undefined;

        return bankAccounts

            .filter ( account => ! account._destroy )

            .map ( account => ( {

                id: account.id || undefined,

                iban: account.iban,

                bankName: account.bankName,

                swiftCode: account.swiftCode || null,

                isEnabled: account.isEnabled !== undefined ? account.isEnabled : true,

                isDefault: account.isDefault !== undefined ? account.isDefault : false

            } ) );

    };

    /** @event useEffect */

    useEffect ( () => {

        if ( complete === true && returnData?.adminCreateLegalData?.legalData?.id ) {

            navigate ( `/app/contacts/legal-data/edit/${ returnData.adminCreateLegalData.legalData.id }` );

        }

    }, [ complete, navigate, returnData ] );

    /** @returns */

    return (

        <section className="mutations create_supplier">

            <Breadcrumbs />

            <form onSubmit={ onSubmit }>

                <AsideEdit aside={

                    <Sidebar

                        __={ t }

                        state={ state }

                        changeAction={ handleChange }

                        errors={ errors }

                        pending={ loading }

                    />

                }>

                    <Fieldset legend={ t ( "legal_entity_information" ) }>

                        <LabeledInput

                            label={ t ( "legal_entity_name" ) }

                            value={ state.legalEntityName }

                            action={ handleChange }

                            name="legalEntityName"

                        />

                        <LabeledInput

                            label={ t ( "registration_number" ) }

                            value={ state.registrationNumber }

                            action={ handleChange }

                            name="registrationNumber"

                        />

                    </Fieldset>

                    <Fieldset legend={ t ( "contact_information" ) }>

                        <LabeledInput

                            label={ t ( "country_code" ) }

                            value={ state.countryCode }

                            action={ handleChange }

                            name="countryCode"

                            placeholder="LV, EE, etc. (leave empty for default)"

                        />

                        <LabeledInput

                            label={ t ( "legal_address" ) }

                            value={ state.legalAddress }

                            action={ handleChange }

                            name="legalAddress"

                            placeholder="Legal address"

                        />

                        <LabeledInput

                            label={ t ( "factual_address" ) }

                            value={ state.factualAddress }

                            action={ handleChange }

                            name="factualAddress"

                            placeholder="Factual/physical address"

                        />

                        <LabeledInput

                            label={ t ( "phone" ) }

                            value={ state.phone }

                            action={ handleChange }

                            name="phone"

                            placeholder="Shop phone number"

                        />

                        <LabeledInput

                            label={ t ( "service_phone" ) }

                            value={ state.servicePhone }

                            action={ handleChange }

                            name="servicePhone"

                            placeholder="Service phone number"

                        />

                        <LabeledInput

                            label={ t ( "email" ) }

                            value={ state.email }

                            action={ handleChange }

                            name="email"

                            placeholder="Contact email"

                        />

                    </Fieldset>

                    <BankAccountsList

                        bankAccounts={ state.bankAccounts || [] }

                        onChange={ handleBankAccountsChange }

                    />

                </AsideEdit>

            </form>

        </section>

    );

},

Sidebar = ( {

    __,

    state = "",

    changeAction = () => { return },

    errors = false,

    pending = false

} ) => {

    return (

        <aside>

            <Fieldset legend={ __ ( "actions" ) }>

                { errors && <div className="errors">

                    <div className="error">

                        { __ ( "error_ocurred" ) }

                    </div>

                </div> }

                <div className={ `mutation-actions default` }>

                    <button className="button add" disabled={ pending }>

                        { __ ( "submit" ) }

                    </button>

                </div>

            </Fieldset>

        </aside>

    );

}

/** @exports AddLegalData */

export default AddLegalData;
